import { EmailVerificationPurpose, UserSystemStatus } from '../../queries';
import { useVerifiedEmailToken } from '../../hooks/use-verified-email-token';
import { RegisterLoading } from '../register-loading/register-loading';
import { InvalidVerificationLink } from '../invalid-verification-link/invalid-verification-link';
import { SuccessfulSignUp } from './successful-sign-up';
import { CompanySignUpForm } from './company-sign-up-form';
import { useCompanySignUp } from './use-company-sign-up';

const COMPANY_SIGN_UP_STATUSES: ReadonlyArray<UserSystemStatus> = [
  UserSystemStatus.CompanyNotInSf,
];

export function CompanySignUp() {
  const verification = useVerifiedEmailToken(
    EmailVerificationPurpose.NewCompany,
    COMPANY_SIGN_UP_STATUSES
  );
  const { signUp, isSuccessful, error } = useCompanySignUp();

  if (verification.status === 'invalid') return <InvalidVerificationLink />;
  if (verification.status === 'pending') return <RegisterLoading />;
  if (isSuccessful) return <SuccessfulSignUp />;
  return (
    <CompanySignUpForm
      email={verification.email}
      error={error}
      onSubmit={signUp}
    />
  );
}

export default CompanySignUp;
